import { useEffect, useState } from 'react';
import useBreakpoint from './useBreakpoint';

const isMobileBreakpoint = (breakpoint?: string) => {
  switch (breakpoint) {
    case 'sm':
    case 'md':
      return true;
    default:
      return false;
  }
};

const useIsMobile = () => {
  const currentBreakpoint = useBreakpoint();
  const [isMobile, setIsMobile] = useState(
    isMobileBreakpoint(currentBreakpoint)
  );

  useEffect(() => {
    setIsMobile(isMobileBreakpoint(currentBreakpoint));
  }, [currentBreakpoint]);

  return isMobile;
};

export default useIsMobile;
